import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRubro = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'rubro',
        name: 'Rubro',
        component: ViewRubro,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
